import React, { useState, useRef, useEffect } from "react";
import Logo from "@/components/Logo";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AsistenteFlotante from "@/components/AsistenteFlotante";
import VideoBienvenida from "@/components/VideoBienvenida";
import PopupTiempo from "@/components/PopupTiempo";
import api from "@/lib/api";
import { ChevronDown, PlayCircle, LogOut } from "lucide-react";

const NAV = [
  { to: "/", label: "MI MESA" },
  { to: "/procesos", label: "MIS PROCESOS" },
  { to: "/mi-empresa", label: "MI EMPRESA" },
];

export default function Layout({ children }) {
  const nav = useNavigate();
  const loc = useLocation();
  const { user, empresa, refreshMe, logout } = useAuth();
  const [menu, setMenu] = useState(false);
  const [verVideo, setVerVideo] = useState(false);
  const menuRef = useRef(null);
  let navItems = empresa?.puertas_abiertas
    ? [...NAV, { to: "/operacion", label: "MI OPERACIÓN" }]
    : NAV;
  if (user?.tiempo_desbloqueada) navItems = [...navItems, { to: "/mi-tiempo", label: "MI TIEMPO" }];

  // Al entrar a cualquier pantalla de adentro, refrescamos los flags de cuenta (desbloqueos de secciones).
  useEffect(() => { refreshMe(); }, [refreshMe]);

  useEffect(() => {
    const onClick = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenu(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="min-h-screen bg-negro flex flex-col">
      <header className="h-16 border-b border-borde flex items-center justify-between px-8 shrink-0">
        <div className="flex items-center gap-10">
          <Logo variant="mark" height={30} onClick={() => nav("/")} />
          <nav className="flex gap-7" data-testid="nav-principal">
            {navItems.map((n) => (
              <button
                key={n.to}
                onClick={() => nav(n.to)}
                data-testid={`nav-${n.to === "/" ? "mesa" : n.to.slice(1)}`}
                className="mono-label transition-colors duration-300"
                style={{ color: loc.pathname === n.to ? "#C9A84C" : "#888888" }}
              >
                {n.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setMenu((v) => !v)}
            className="flex items-center gap-2 mono-label text-gris hover:text-crema transition-colors"
            data-testid="cuenta-menu-btn"
          >
            <span className="hidden md:block">{empresa?.nombre || "MI CUENTA"}</span>
            <ChevronDown size={14} />
          </button>
          {menu && (
            <div
              className="absolute right-0 mt-3 w-64 rounded-xl overflow-hidden z-50"
              style={{ background: "#111", border: "1px solid #2A2A2A", boxShadow: "0 12px 40px rgba(0,0,0,0.6)" }}
              data-testid="cuenta-menu"
            >
              <button
                onClick={() => { setMenu(false); setVerVideo(true); }}
                className="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5"
                data-testid="ver-video-bienvenida"
                style={{ fontSize: 13, color: "#D8D8D8" }}
              >
                <PlayCircle size={16} className="text-dorado shrink-0" />
                Ver el video de bienvenida
              </button>
              <div style={{ height: 1, background: "#2A2A2A" }} />
              <button
                onClick={async () => { setMenu(false); await logout(); nav("/login"); }}
                className="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5"
                data-testid="nav-salir"
                style={{ fontSize: 13, color: "#D8D8D8" }}
              >
                <LogOut size={16} className="text-gris shrink-0" />
                Salir
              </button>
            </div>
          )}
        </div>
      </header>

      <div className="flex flex-1 min-h-0">
        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>

      <AsistenteFlotante />
      {verVideo && <VideoBienvenida manual onDone={() => setVerVideo(false)} />}
      {user?.tiempo_desbloqueada && !user?.tiempo_pop_visto && (
        <PopupTiempo
          nombre={(user?.nombre || "").split(" ")[0]}
          empresa={empresa?.nombre}
          onCerrar={async () => { try { await api.post("/tiempo/pop-visto"); } catch {} refreshMe(); }}
        />
      )}
    </div>
  );
}
